'use strict'

/* eslint-disable no-console */
import {Tracking, TrackingEvent} from '@common/tracking'
import {addPrices} from './prices-calc'
import {addHelp} from './prices-help'
import {addPriceRoi} from './prices-roi'

export class PricesController {
  private static clickToDownloadPlatformPresentation(): void {
    const downloadBtn = document.getElementById(
      'click-to-download-platform-presentation'
    )
    if (downloadBtn) {
      downloadBtn.addEventListener('click', (e: Event) => {
        e.preventDefault()
        Tracking.send(TrackingEvent.landingDownloadPresentationAboutPlatform)
        window.open('/media/docs/platform-presentation.pdf', '_blank') // Open in a new tab
      })
    }
  }

  private static clickToCallDownloadPopupForBox(): void {
    const trigger = document.getElementById('trigger-posthog-download-box')
    if (trigger) {
      trigger.addEventListener('click', (e: Event) => {
        e.preventDefault()
        Tracking.send(TrackingEvent.landingDownloadBoxInstallationFile)
      })
    }
  }

  private static clickToCallDownloadPopupForPlatform(): void {
    const trigger = document.getElementById('trigger-posthog-download-platform')
    if (trigger) {
      trigger.addEventListener('click', (e: Event) => {
        e.preventDefault()
        Tracking.send(TrackingEvent.landingDownloadPlatformInstallationFile)
      })
    }
  }

  static init(): void {
    addPrices()
    addPriceRoi()
    addHelp()
    this.clickToDownloadPlatformPresentation()
    this.clickToCallDownloadPopupForBox()
    this.clickToCallDownloadPopupForPlatform()
  }
}
